import Uiconstants from '../../lib/UIconstants';
import { ProgressiveBonusSlide_1 } from './slides/ProgressiveBonusSlide_1';
import { ProgressiveBonusSlide_2 } from './slides/ProgressiveBonusSlide_2';
// import { ProgressiveBonusSlide_3 } from "./slides/ProgressiveBonusSlide_3";
// import { ProgressiveBonusSlide_4 } from "./slides/ProgressiveBonusSlide_4";
import PaginationController from '../../controllers/PaginationController';
import SplashScreenController from '../../controllers/splash_screen/SplashScreenController';

import { SplashScreenViewGrid } from './SplashScreenViewGrid';

import MainGridController from '../../controllers/grid/MainGridController';
import { isDesktop } from 'react-device-detect';
// import { CustomAssets } from "./elements/CustomAssets";

export const SplashScreenView = {
	name: 'splash_screen_view_holder',
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: PaginationController,
			name: 'PaginationController',
			config: {
				item: 'pagination',
				val: 'pagination',
				slides: [
					{ slide: 'progressive_bonus_slide_1', index: 0 },
					{ slide: 'progressive_bonus_slide_2', index: 1 }
					// { slide: "progressive_bonus_slide_4", index: 2 },
				],
				pagination: [
					{
						active: 'bullet_1',
						inactive: 'bullet_inactive_1',
						index: 0
					},
					{
						active: 'bullet_2',
						inactive: 'bullet_inactive_2',
						idnex: 1
					}

					// {
					//   active: "bullet_4",
					//   inactive: "bullet_inactive_4",
					//   index: 2,
					// },
				],
				pagination_bullet_active: 'checkbox_active',
				pagination_bullet_inactive: 'checkbox_inactive',
				position: {
					width: 982 / 2 + 152,
					x: 0,
					y: 0
				}
			}
		},
		{
			Controller: SplashScreenController,
			name: 'SplashScreenController',
			config: {
				btn: Uiconstants.SPLASH_SCREEN_BTN,
				checkbox: Uiconstants.SPLASH_SCREEN_CHECKBOX,
				item: 'splash_screen_view_holder',
				val: 'splash_screen_view_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'MainGridController',
			config: SplashScreenViewGrid
		}
	],
	components: [
		{
			name: 'logo',
			type: 'Sprite',
			components: [
				{
					name: 'logo_img',
					type: 'Sprite',
					img: 'logo',
					position: {
						x: 0,
						y: 0
					}
				}
			]
		},
		isDesktop
			? {
					name: 'fg',
					type: 'Sprite',
					components: [
						{
							name: 'fg',
							type: 'AnimatedSprite',
							position: { x: 15, y: -5 },
							animation: {
								pattern: 'mciddle_000$.png',
								start: 0,
								end: 51,
								speed: 0.5,
								precision: 2,
								loop: true,
								scale: {
									x: 0.5,
									y: 0.5
								}
							}
						}
					]
				}
			: {
					name: 'fg',
					type: 'Sprite',
					components: [
						{
							name: 'fg',
							type: 'Sprite',
							img: 'main_character_m',
							position: { x: -5, y: 0 },
							scale: {
								x: 0.7,
								y: 0.7
							}
						}
					]
				},
		{
			name: 'slider_bg',
			type: 'Sprite',
			components: [
				{
					name: 'settings_page_main_bg',
					type: 'Sprite',
					img: 'splash_bg',
					position: {
						x: 0,
						y: 0
					},
					scale: {
						x: isDesktop ? 1 : 2,
						y: isDesktop ? 1 : 2
					}
				},
				{
					name: 'splash_page_border',
					type: 'Sprite',
					img: 'splash_border',
					position: { x: 0, y: -8 },
					scale: {
						x: isDesktop ? 1 : 2,
						y: isDesktop ? 1 : 2
					}
				},
				{
					name: 'progressive_bonus_slide_1',
					position: { x: 0, y: 0 },
					type: 'VisualComponent',
					component: ProgressiveBonusSlide_1
				},
				{
					name: 'progressive_bonus_slide_2',
					position: { x: 0, y: 0 },
					type: 'VisualComponent',
					component: ProgressiveBonusSlide_2
				},
				{
					name: 'pagination',
					type: 'Sprite',
					position: { x: 0, y: 0 },
					components: [
						{
							name: 'arrow_left',
							type: 'SimpleButton',
							position: { x: -11, y: 336 },
							bg: 'pagination_arrow_left'
						},
						{
							name: 'arrow_right',
							type: 'SimpleButton',
							position: { x: 988, y: 336 },
							bg: 'pagination_arrow_right'
						},
						{
							name: 'pagination_holder',
							type: 'Sprite',
							position: { x: 0, y: 0 }
						}
					]
				}
				// {
				//   name: "CustomAssets",
				//   position: { x: 0, y: 0 },
				//   type: "VisualComponent",
				//   component: CustomAssets,
				// },
			]
		},
		{
			name: 'texts',
			type: 'Sprite',
			components: [
				{
					name: 'volatility',
					type: 'Sprite',
					position: { x: 0, y: -45 },
					img: 'volatility'
				}
			]
		},
		{
			name: Uiconstants.SPLASH_SCREEN_BTN,
			type: 'Sprite',
			components: [
				{
					name: 'btn_holder',
					type: 'Sprite',
					components: [
						{
							name: 'btn',
							type: 'SimpleButton',
							bg: 'spin_btn',
							icon: 'spin_icon',
							position: {
								x: 0,
								y: 60
							}
						}
					]
				}
			]
		},
		{
			name: Uiconstants.SPLASH_SCREEN_CHECKBOX,
			type: 'Sprite',
			components: [
				{
					name: 'cb',
					type: 'SwitchButton',
					position: { x: 0, y: -54 },
					bg: 'checkbox_active',
					fg: 'checkbox_inactive'
				},
				{
					name: 'cbtext',
					type: 'SwitchButton',
					position: { x: 28, y: -58 },
					text: 'SPLASH_SCREEN_CHECKBOX'
				}
			]
		}
	]
};
